module.exports = __webpack_public_path__ + "img/ma257.49829424.png";